import { XHubbleAccessData } from "src/types/type";

export default function ymcHeaderDecode(ymcData: string): XHubbleAccessData {
  let ret = null;
  try {
    if (/^\d+$/.test(ymcData)) {
      const byteStrings = ymcData.match(/\d{3}/g);
      if (byteStrings) {
        const byteArray = byteStrings.map(byteString => (parseInt(byteString) - 188 + 256) % 256);
        const charArray = byteArray.map(byte => String.fromCharCode(byte));
        ymcData = charArray.join('');
      }
    }
    ret = JSON.parse(ymcData);
  } catch (error) {
    hbLogger.warn('ymcHeaderDecode 解析异常', ymcData);
  }
  return ret;
}
